import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from 'src/app/core/auth.service';

/**
 * Add the template content to the DOM unless the condition is true.
 */
@Directive({ selector: '[eosViewTeamInfo]'})
export class ViewTeamInfo implements OnInit {

    @Input('eosViewTeamInfo') team:string;
    
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private auth:AuthService) { }


    ngOnInit(){
        if (this.checkAccess()) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }
  

  checkAccess() {
    return (this.auth.isAuthorised(`${this.team}-View`) || this.auth.isAuthorised(`${this.team}-Edit`));
  }
}